import { Input } from 'antd'
import Axios from 'axios'
import L from 'leaflet'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'
import 'leaflet/dist/leaflet.css'
import moment from 'moment'
import React from 'react'
import { Map, TileLayer } from 'react-leaflet'
import MarkerCluster from './markerCluster'

// let DefaultIcon = L.icon({
//     iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
//     shadowUrl: iconShadow,
// })
// L.Marker.prototype.options.icon = DefaultIcon

let green = L.icon({
    iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
    shadowUrl: iconShadow,
})

let red = L.icon({
    iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
    shadowUrl: iconShadow,
})

let yellow = L.icon({
    iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-yellow.png',
    shadowUrl: iconShadow,
})

interface IProps {}

interface IState {
    viewport: any
    data: any[]
    config: any[]
    search: string
    devices: any[]
}

const Home: React.FC<IProps> = (props) => {
    const [state, setState] = React.useState<IState>({
        viewport: {
            center: [22.28552, 114.15769],
            zoom: 15,
        },
        data: [],
        config: [],
        search: '',
        devices: [],
    })

    const mapRef = React.createRef<Map>()

    React.useEffect(() => {
        Axios.get('/config')
            .then((res: any) => {
                Axios.get('/devices', { params: { installed: ['yes'] } })
                    .then((device) => {
                        const hours = Number(res.data.hour)
                        const devices: any[] = []
                        device.data.forEach((row: any) => {
                            const online = row.latest
                                ? moment(row.latest.recordedAt).isBetween(moment().subtract({ hours: hours }), moment())
                                : false

                            if (
                                !row.location ||
                                !row.location.latitude ||
                                !row.location.longitude ||
                                row.installed === 'no'
                            )
                                return

                            let icon

                            const alert = row.latest ? row.latest.alert : -1

                            if (online) {
                                icon = green
                                if (String(alert) === '88' || String(alert) === '1') {
                                    icon = yellow
                                }
                            } else {
                                icon = red
                            }

                            devices.push(
                                L.marker(
                                    { lat: row.location.latitude, lng: row.location.longitude },
                                    {
                                        icon,
                                    }
                                ).bindPopup(row.title)
                            )
                        })
                        setState((prev) => ({
                            ...prev,
                            data: device.data,
                            devices,
                            config: res.data,
                        }))
                    })
                    .catch((er) => {
                        console.error(er)
                    })
            })
            .catch((err) => {
                console.error(err)
            })
    }, [])

    const handleClick = () => {
        const map = mapRef.current
        if (map != null) {
            map.leafletElement.locate()
        }
    }

    const handleChange = (evt: any) => {
        setState({
            ...state,
            search: evt.target.value,
        })
    }

    return (
        <div>
            <Input
                style={{ maxWidth: '300px' }}
                onChange={handleChange}
                onPressEnter={(e) => {
                    const map = mapRef.current
                    if (map) {
                        const row = state.data.find((row) => row.title === state.search)
                        if (row) {
                            const center: L.LatLngLiteral = {
                                lat: row.location.latitude,
                                lng: row.location.longitude,
                            }
                            // map.leafletElement.setView(center, 18)
                            const marker = state.devices.find((e) => e.getPopup().getContent() === row.title)

                            if (marker) {
                                // map.leafletElement.flyTo(center)
                                let parent: any = L.markerClusterGroup().getVisibleParent(marker)
                                console.log(parent)
                                if (parent && parent.spiderfy) {
                                    parent.zoomToBounds()
                                    parent.spiderfy()
                                } else {
                                    map.leafletElement.setView(center, 18)
                                }
                                marker.openPopup()
                            }

                            // const marker: React.RefObject<Marker<MarkerProps, L.Marker<any>>> = markerRef[row.title]
                            // if(marker.current) {
                            //     marker.current.leafletElement.openPopup()
                            // }
                        }
                    }
                }}
            />
            <Map
                style={{ width: '100%', height: '800px' }}
                viewport={state.viewport}
                ref={mapRef}
                onclick={handleClick}
                maxZoom={18}
            >
                <TileLayer
                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {state.devices.length > 0 ? <MarkerCluster markers={state.devices} /> : null}
                {/* {state.data.map((row, index) => {
                    const hours = Number(state.config.find(h => h.name === 'Hour').value)
                    const online = row.latest ? moment(row.latest.recordedAt).isBetween(moment().subtract({hours: hours}), moment()) : false
                    const ref = React.createRef<Marker>()
                    markerRef[row.title] = ref
                    return row.location && row.location.latitude && row.location.longitude? (
                        <Marker
                            position={{ lat: row.location.latitude, lng: row.location.longitude }}
                            opacity={1}
                            ref={ref}
                            icon={online ? green : red}
                            key={`marker-${index}`}
                        >
                            <Popup>{row.title}</Popup>
                        </Marker>
                    ) : null
                })} */}
            </Map>
        </div>
    )
}

export default Home
